import { useCallback, useEffect, useState } from "react";

import "./style.css";
import api from "@/api";
import Text from "@/components/Text";
import Comment from "@/components/SatisfactionSurvey/Comment";
import Rating from "@/components/Rating";

const ORIGEM = "ECOMMERCE";

interface ContentRatingProps {
  saleId: number | null;

  setShowAcknowledgment(showAcknowledgment: boolean): void;
}

const ContentRating = ({
  saleId,
  setShowAcknowledgment,
}: ContentRatingProps) => {
  const [starSelected, setStarSelected] = useState(0);
  const [idSatisfactionSurvey, setIdSatisfactionSurvey] = useState(0);
  const [sendRating, setSendRating] = useState(false);
  const [comment, setComment] = useState("");

  const createRating = useCallback(() => {
    const body = {
      venda_id: saleId,
      nota: starSelected,
      origem: ORIGEM,
    };

    api.post(`/core/pesquisa-satisfacao`, body).then(({ data }) => {
      setIdSatisfactionSurvey(data.id);
    });
  }, [saleId, starSelected]);

  useEffect(() => {
    if (starSelected === 5) {
      setShowAcknowledgment(true);
    }

    if (starSelected >= 1 && starSelected < 5) {
      setShowAcknowledgment(false);
    }

    if (starSelected !== 0) {
      createRating();
    }
  }, [createRating, setShowAcknowledgment, starSelected]);

  useEffect(() => {
    if (sendRating) {
      api
        .put(`/core/pesquisa-satisfacao/${idSatisfactionSurvey}`, {
          melhoria: comment,
        })
        .then(({ data }) => {
          setIdSatisfactionSurvey(data.id);
          setSendRating(false);
          setShowAcknowledgment(true);
        });
    }
  }, [
    comment,
    idSatisfactionSurvey,
    sendRating,
    setIdSatisfactionSurvey,
    setShowAcknowledgment,
  ]);

  function handleChangeComment(newComment: string) {
    setComment(newComment);
  }

  return (
    <>
      <Text
        as="span"
        className="mt-1 block font-bold leading-none"
        size="1xl"
        kind="blue"
      >
        Como foi sua experiência de comprar com a TIM?
      </Text>
      <Text
        as="span"
        className="mt-2 block font-normal leading-none"
        size="xs"
        kind="gray"
      >
        Escolha de 1 a 5 estrelas para classificar.
      </Text>
      <div className="divRating">
        <Rating starSelected={starSelected} setStarSelected={setStarSelected} />
      </div>
      {starSelected > 0 && starSelected < 5 && (
        <>
          <Comment
            comment={comment}
            handleChangeComment={handleChangeComment}
          />
          <button
            type="button"
            className="buttonSend"
            onClick={() => setSendRating(true)}
          >
            Enviar
          </button>
        </>
      )}
    </>
  );
};

export default ContentRating;
